/**
 * MoveHistoryUI implementation manages expansion state for move history entries.
 * It maintains a Set of expanded move IDs as a reactive signal, providing methods
 * to toggle, expand, collapse individual moves, or collapse all moves at once.
 * The Set is recreated on each change to ensure signal reactivity triggers properly.
 */
import { signal } from '@preact/signals-react'
import type { MoveHistoryUI, MoveHistoryUIDeps } from './moveHistoryUI.types'

export function makeMoveHistoryUI(_deps: MoveHistoryUIDeps = {}): MoveHistoryUI {
  const expandedMoves = signal<Set<string>>(new Set())

  function toggleMove(moveId: string): void {
    const newSet = new Set(expandedMoves.value)
    if (newSet.has(moveId)) {
      newSet.delete(moveId)
    } else {
      newSet.add(moveId)
    }
    expandedMoves.value = newSet
  }

  function expandMove(moveId: string): void {
    const newSet = new Set(expandedMoves.value)
    newSet.add(moveId)
    expandedMoves.value = newSet
  }

  function collapseMove(moveId: string): void {
    const newSet = new Set(expandedMoves.value)
    newSet.delete(moveId)
    expandedMoves.value = newSet
  }

  function collapseAll(): void {
    expandedMoves.value = new Set()
  }

  return {
    expandedMoves,
    toggleMove,
    expandMove,
    collapseMove,
    collapseAll
  }
}

